import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-new-showall-gallery',
  templateUrl: './new-showall-gallery.component.html',
  styleUrls: ['./new-showall-gallery.component.scss']
})
export class NewShowallGalleryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
